import { render, staticRenderFns, recyclableRender, components } from "./creationSubmit.vue?vue&type=template&id=334d2089&scoped=true&"
var renderjs
import script from "./creationSubmit.vue?vue&type=script&lang=js&"
export * from "./creationSubmit.vue?vue&type=script&lang=js&"
import style0 from "./creationSubmit.vue?vue&type=style&index=0&id=334d2089&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334d2089",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/creationCenter/creationSubmit.vue"
export default component.exports